import React, { useEffect } from "react";
import { useState} from "react";


function App() {
  const [Count, setCount] = useState(() => {
    const saved = localStorage.getItem("Count");
    return saved !==null ? JSON.parse(saved) : 0;
  });
  useEffect(() => {
    localStorage.setItem("Count", JSON.stringify(Count));
  }, [Count]);

  return (
  <div className="container my-5">
    <div className="text-center"><h1>Counter app</h1>
    <div className="card-body">
      <h2 className="my-5">{Count}</h2>
    </div>
    <div className="buttons">
      <button className="btn btn-success mx-3"onClick={()=>setCount(Count+1)}>Increment</button>
      <button className="btn btn-danger mx-3" onClick={()=>setCount(Count-1)}>Decrement</button>
      <button className="btn btn-secondary mx-3"onClick={()=>setCount(0)}>Reset</button>
      
    </div>
    </div>
  </div>
  );
}

export default App;
